import { useState } from 'react';
import { SectionLabel } from '@/components/marketing/v2/SectionLabel';
import { NeobrutalButton } from '@/components/marketing/v2/NeobrutalButton';
import { BAR_FAQ } from './barFaqData';

export default function BarFaqV2() {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section className="bg-white py-20 md:py-28">
      <div className="mx-auto max-w-4xl px-6 md:px-8">
        <div className="text-center">
          <SectionLabel className="justify-center">Questions fréquentes</SectionLabel>
          <h2 className="mt-4 font-marketing-display text-[clamp(30px,4.2vw,54px)] font-bold leading-[1] tracking-[-0.035em] text-charcoal-800">
            Pour cost, écart, hors ligne&nbsp;: <span className="underline-lime">on t’explique.</span>
          </h2>
        </div>

        <ul className="mt-12 space-y-4">
          {BAR_FAQ.map((item, idx) => {
            const isOpen = open === idx;
            return (
              <li key={item.q} className="border-2 border-charcoal-800 bg-paper shadow-neobrutal-4">
                <button
                  type="button"
                  aria-expanded={isOpen}
                  onClick={() => setOpen(isOpen ? null : idx)}
                  className="flex w-full cursor-pointer items-center justify-between gap-4 px-6 py-5 text-left font-marketing-display text-[16px] font-bold text-charcoal-800 md:text-lg"
                >
                  <span>{item.q}</span>
                  <span
                    className={`flex h-8 w-8 flex-shrink-0 items-center justify-center border-2 border-charcoal-800 transition-colors ${isOpen ? 'bg-lime-500 text-charcoal-800' : 'bg-white text-charcoal-700'}`}
                    aria-hidden="true"
                  >
                    <svg
                      width="14"
                      height="14"
                      viewBox="0 0 14 14"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2.6"
                      className={`transition-transform ${isOpen ? 'rotate-45' : ''}`}
                    >
                      <path d="M7 2v10" />
                      <path d="M2 7h10" />
                    </svg>
                  </span>
                </button>
                {isOpen && (
                  <div className="border-t-2 border-charcoal-800 px-6 py-5 font-marketing-body text-[15px] leading-relaxed text-charcoal-600">
                    {item.a}
                  </div>
                )}
              </li>
            );
          })}
        </ul>

        <div className="mt-12 text-center">
          <p className="mb-5 font-marketing-body text-[15px] text-charcoal-600">
            Une autre question sur le contrôle des coûts de ton bar&nbsp;?
          </p>
          <NeobrutalButton as="link" to="/contact" variant="primary" size="md">
            Parler à l’équipe
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
              <path d="M5 12h14" />
              <path d="M13 6l6 6-6 6" />
            </svg>
          </NeobrutalButton>
        </div>
      </div>
    </section>
  );
}
